import MAP from "../constants/map.constants";

var originFetch;
function envUrl() {
    if (location.port == '8081')
        return 'http://cms.hongyikeji.com:81';
    else
        return 'http://'+location.host+':81';
}
let LINK_URL = "http://cms.hongyikeji.com:81";
export default{
    getLinkUrl
};

export function getLinkUrl(){
    return LINK_URL;
}

(function (self) {
    'use strict';

    async function checkStatus(method,response) {
        if (response.status >= 200 && response.status < 300) {
            if(method == 'GET' || response.status == 201 || response.status == 202) {
                var json = await response.json();
                if (response.status == 201) {
                    await checkTokenTimeout(json);
                }
                return json;
            } else if(method == 'POST' && response.url.indexOf('/xlsx/of') > -1){
                var json = await response.json();
                await checkTokenTimeout(json);
                return json;
            }
            else return {};
        } else if (response.status == 401) {
            localStorage.removeItem('Token');
            window.location.reload();
        }

        var error = new Error(response.statusText);
        error.code = response.status;
        error.url = response.url;
        error.method = response.method;
        console.log('error', error.method,error.url);
        throw error;
    }

    var renewalEnabled = false;
    async function checkTokenTimeout(response) {
        if(response && response.token != null) {
            if (response.token.length == 0) {
                renewalEnabled = false;
                localStorage.setItem('Token', null);
            } else {
                localStorage.setItem('Token', response.token);

                if (response.tokenTimeout > 0) {
                    var timeout = response.tokenTimeout * 900;
                    renewalEnabled = true;

                    setTimeout(function () {
                        var token = localStorage.getItem('Token');
                        if (renewalEnabled && token != null)
                            self.patch('/token');
                    }, timeout);
                }
            }
        } else if (window.location.pathname == '/home') {
            var token = localStorage.getItem('Token');

            if (!renewalEnabled && originFetch && token != null) {
                renewalEnabled = true;
                self.patch('/token')
            }
        }

        return response;
    }

    if (self.fetch) {
        originFetch = self.fetch;
        self.fetch = async function (input, init = {}, timeout) {
            var response;
            var isApi = false;

            if (input.url != null){
                if((input.url.startsWith(MAP.MAP_URL_REPLACE) || input.url.startsWith(envUrl()))
                    && (input.url.endsWith("sprite.png")
                        || input.url.endsWith(".json"))){
                    var token = localStorage.getItem('Token');
                    token == null ? '' : token;
                    input.headers.append('Token', token);
                }
                return await originFetch(input, init);
            }

            if (timeout == null && typeof(init) == "number") {
                timeout = init;
            }
            if (init == null || typeof(init) != "object") {
                init = {};
            }

            if(input.toLowerCase().indexOf('http:') < 0) {
                isApi = true;
                if(location.port == '8082') {
                    input = 'http://' + location.hostname + ':8081' + input;
                } else if(location.port == '8081') {
                   // let kUrl = 'http://192.168.18.70:81';
                   let kUrl = 'http://cms.hongyikeji.com:81';
                    // Do Noting
                    // input = 'http://localhost:81' + input;
                     input = kUrl + input;
                  // input = 'http://cms.hongyikeji.com:81' + input;
                    LINK_URL = kUrl;
                } else {
                    LINK_URL = 'http://' + location.hostname + ':81';
                    input = 'http://' + location.hostname + ':81' + input;
                }
            }

            if(isApi) {
                // 判断是否为上传文件
                if (init.customField) {
                    init.body = new FormData();
                    
                    init.body.append('file', init.customField.get('file'))
                    init.body.append('label', init.customField.get('label'))
                }

                if (!init.method) init.method = "POST";
                init.credentials = 'omit';
                init.mode = 'cors';
                if (init.headers == undefined || init.headers == null) init.headers = {};
                if(init.body == null || typeof init.body == 'string'){
                    init.headers['Content-Type'] = 'application/json; charset=utf-8';
                }

                var token = localStorage.getItem('Token');
                init.headers['Token'] = token == null ? '' : token;
            } else if (!init.method) init.method = "GET";

            if(typeof timeout === 'number' && timeout > 0 && AbortController) {
                const controller = new AbortController();
                const {signal} = controller;
                init.signal = signal;
                const fetchPromise = originFetch(input, init);
                const timeoutPromise = new Promise(function (resolve, reject) {
                    setTimeout(() => {
                        //reject(new Error(`Fetch Timeout ${timeout}`));
                        resolve(new Response("timeout", { status: 408, statusText: "timeout " }));
                        controller.abort();
                    }, timeout);
                });

                response = await Promise.race([fetchPromise, timeoutPromise]);
            }
            else response =  await originFetch(input, init);

            // 判断请求的是否是文件流
            if (timeout && timeout.responseType == 'blob')
                return response;

            if(!isApi) return response;

            response = await checkStatus(init.method,response);

            return response;
        }

        self.get = function (input, params, timeout) {
            if (timeout == null && typeof(params) == "number") {
                timeout = params;
            }
            if (params && typeof(params) == "object") {
                let paramsArray = [];
                //拼接参数
                Object.keys(params).forEach(key => {
                    var value = params[key];
                    var encodedValue = encodeURIComponent(value);
                    if(value instanceof Array) {
                        paramsArray.push(key + '=' + encodeURIComponent(value.join(',')));
                    }
                    else if(value instanceof String && value.startsWith('>=')) paramsArray.push(key + '>=' + encodedValue.substring(2));
                    else if(value instanceof String && value.startsWith('<=')) paramsArray.push(key + '<=' + encodedValue.substring(2));
                    else if(value instanceof String && value.startsWith('>')) paramsArray.push(key + '>' + encodedValue.substring(1));
                    else if(value instanceof String && value.startsWith('<')) paramsArray.push(key + '<' + encodedValue.substring(1));
                    else paramsArray.push(key + '=' + encodedValue)
                });
                if (input.search(/\?/) === -1) {
                    input += '?' + paramsArray.join('&')
                } else {
                    input += '&' + paramsArray.join('&')
                }
            }
            var init = {method:"GET"};
            return self.fetch(input, init, timeout);
        }

        self.post = function (input, init = {}, timeout) {
            if (timeout == null && typeof(init) == "number") {
                timeout = init;
            }
            if (init == null || typeof(init) != "object") {
                init = {};
            }
            init.method = "POST";

            return self.fetch(input, init, timeout);
        }

        self.patch = function (input, init = {}, timeout) {
            if (timeout == null && typeof(init) == "number") {
                timeout = init;
            }
            if (init == null || typeof(init) != "object") {
                init = {};
            }
            init.method = "PATCH";
            return self.fetch(input, init, timeout);
        }

        self.put = function (input, init = {}, timeout) {
            if (timeout == null && typeof(init) == "number") {
                timeout = init;
            }
            if (init == null || typeof(init) != "object") {
                init = {};
            }
            init.method = "PUT";
            return self.fetch(input, init, timeout);
        }

        self.del = function (input, timeout) {

            var init = {method:"DELETE"};

            return self.fetch(input, init, timeout);
        }

        checkTokenTimeout();
    }
})(typeof self !== 'undefined' ? self : this);



// WEBPACK FOOTER //
// ./src/apis/http.js